import React, { useContext } from 'react'
import { AppContext } from '../../store'
import './style.scss'

const loadingImg = require('../../assets/images/loading.svg')

export default () => {
  const { state: { loading } } = useContext(AppContext)

  return loading && (
    <section className="loading">
      <div className="loading__overlay">
        <img
          src={loadingImg}
          alt="Carregando"
          className="loading__icon"
        />
      </div>
    </section>
  )
}
